import { render, staticRenderFns } from "./ReporteRecibidos.vue?vue&type=template&id=47611d94&scoped=true"
import script from "./ReporteRecibidos.vue?vue&type=script&lang=js"
export * from "./ReporteRecibidos.vue?vue&type=script&lang=js"
import style0 from "./ReporteRecibidos.vue?vue&type=style&index=0&id=47611d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47611d94",
  null
  
)

export default component.exports